import { makeStyles } from "@mui/styles";

export const useAuthFieldStyles = makeStyles(() => ({
  fieldInput: {
    width: "100%",
    height: "52px",
    border: "1px solid rgba(204, 209, 217, 0.2)",
    borderRadius: "8px",
    padding: "0 20px",
    fontSize: "16px",
    fontFamily: "'DM Sans', sans-serif",
    color: "#2E384D",
    background: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(5px)",
    boxShadow: "0px 0px 26px 0px rgba(0, 0, 0, 0.06)",
    outline: "none",
    boxSizing: "border-box",
    "&::placeholder": {
      color: "#99a1ab",
      fontSize: "12px",
      opacity: 1,
    },
    "&:disabled": {
      opacity: 0.7,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  phoneInput: {
    flex: 1,
    height: "100%",
    border: "none",
    outline: "none",
    fontSize: "14px",
    fontFamily: "'DM Sans', sans-serif",
    color: "#2E384D",
    background: "transparent",
    minWidth: 0,
    "&::placeholder": {
      color: "#99a1ab",
      fontSize: "12px",
      opacity: 1,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  otpContainer: {
    height: "56px",
    width: "100%",
  },
  otpInput: {
    height: "56px",
    width: "57px",
    border: "1px solid #CCD1D9",
    borderRadius: "8px",
    flex: "1",
  },
  otpResend: {
    color: "#2977ec",
    background: "transparent !important",
    padding: "0",
    boxShadow: "none !important",
    fontSize: "12px",
    display: "inline",
    textTransform: "none",
    cursor: "pointer",
    minWidth: "auto",
    marginRight: "8px",
  },
}));

export const authPrimaryButtonSx = {
  width: "100%",
  height: "42px",
  borderRadius: "12px",
  background:
    "linear-gradient(173deg, rgb(0, 126, 240) 0%, rgb(2, 118, 222) 100%)",
  boxShadow: "0px 2.25px 7.38px 3.44px rgba(41, 119, 236, 0.3)",
  border: "0.563px solid #393939",
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "'DM Sans', sans-serif",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  "&:hover": {
    background:
      "linear-gradient(173deg, rgb(0, 110, 210) 0%, rgb(2, 100, 190) 100%)",
  },
  "&.Mui-disabled": {
    background: "#dcdcdc",
    boxShadow: "none",
    border: "none",
  },
};
